import React, { useCallback, useEffect } from "react";
import { useRouter } from "next/router";
import Head from "next/head";

import RecipeDetailPage from "@/containers/RecipeDetailPage";
import RecipeListPage from "@/containers/RecipeListPage";

import { useAppDispatch } from "@/hooks";

import * as actions from "@/redux/RecipeReducer";
import { checkRecipeSlugType, generateMetaData } from "./util";

const RecipeSlugListingPage = ({ postData }: any) => {
  const router = useRouter();
  const dispatch = useAppDispatch();

  const recipeSlug = router?.query?.recipeSlug?.[0];
  const pageTypeData = checkRecipeSlugType(recipeSlug);

  const { isAttributeType, isCollectionType, isRecipeType, slug } =
    pageTypeData;

  const getRecipeThreadByID = useCallback(
    () => dispatch(actions.getRecipeThreadByID({ id: slug })),
    [dispatch, slug]
  );

  const getRecipeByCollectionSlug = useCallback(
    () => dispatch(actions.getRecipeByCollectionSlug({ id: slug })),
    [dispatch, slug]
  );

  const getRecipeByAttributeSlug = useCallback(
    () => dispatch(actions.getRecipeByAttributeSlug({ id: slug })),
    [dispatch, slug]
  );

  useEffect(() => {
    if (isAttributeType) {
      getRecipeByAttributeSlug();
    }
    if (isCollectionType) {
      getRecipeByCollectionSlug();
    }
    if (isRecipeType) {
      getRecipeThreadByID();
    }
  }, [isAttributeType, isCollectionType, isRecipeType]);

  let { title, description, thumbnail, canonicalURL } = generateMetaData(
    postData,
    pageTypeData
  );

  const getPageComponent = () => {
    if (isRecipeType) {
      return <RecipeDetailPage />;
    }
    if (isCollectionType) {
      return (
        <RecipeListPage
          hasRecipeGroupedByParameter={true}
          pageType="COLLECTION"
          recipeSlug={slug}
        />
      );
    }
    if (isAttributeType) {
      return (
        <RecipeListPage
          hasRecipeGroupedByParameter={true}
          pageType="ATTRIBUTES"
          recipeSlug={slug}
        />
      );
    }
  };
  description = `Recipe for ${title} | ${description}`;

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:site_name" content="Shyft" />
        <meta property="og:image" content={thumbnail} />
        <meta name="twitter:card" content="summary_large_image" />
        {canonicalURL && (
          <link rel="canonical" href={canonicalURL} key="canonical" />
        )}
      </Head>
      {getPageComponent()}
    </>
  );
};

export default RecipeSlugListingPage;
